<div class="overflow-hidden" (click)="cancelFocus()">
  <que-create-header (saveEvent)="saveFromBtn()"></que-create-header>
  <div>

    <!-- changeNotSavedInCurrentStep {{changeNotSavedInCurrentStep$()}} -->
    <div cdkDropListGroup class="warpper-flex-row">

      <div class="warp-menu">
        <div class="title">
          <div class="pointer changeStatusMenu" (click)="changeStatusComponentMenu()">
            <img src="/assets/images/types/dropdown-big.svg" [ngClass]="{'open-img':isOpenAddComponents}" />
            <span translate *ngIf="!currentTab">
              menuTypes.title
            </span>
            <span translate *ngIf="currentTab">
              menuTypes.secondTitle
              <!-- <img src="/assets/images/question-menu/question-sign.svg" class="question-sign" /> -->
            </span>
          </div>
          <div class="tabs">
            <div translate (click)="changeTab(0)" class="img-tab" [ngClass]="{'active':!currentTab}">
              <svg-icon svgClass="img-tab-svg" src="/assets/images/types/components-icon.svg"></svg-icon>
            </div>
            <div translate (click)="changeTab(1)" class="img-tab" [ngClass]="{'active':currentTab}">
              <svg-icon svgClass="img-tab-svg" src="/assets/images/types/smart-black.svg"></svg-icon>
            </div>
          </div>
        </div>
        <div class="warp-scroll" [ngClass]="{'half-scroll':isOpenStepMenu}" *ngIf="isOpenAddComponents">
          <que-question-type-menu *ngIf="currentTab==0; else templateComponents"
            (addTypeQuestionEmit)="addTypeQuestionsToBoard($event)"></que-question-type-menu>
          <ng-template #templateComponents>
            <que-collection-questions (addQuestionEmit)="addQuestionFromCollection($event)"></que-collection-questions>
          </ng-template>
        </div>
        <div class="title steps">
          <div class="pointer changeStatusMenu" (click)="changeStatusStepMenu()">
            <img src="/assets/images/types/dropdown-big.svg" [ngClass]="{'open-img':isOpenStepMenu}" />
            <span translate>
              menuTypes.stepsTitle
            </span>
          </div>
          <!-- *ngIf="!isPreview " -->
          <div class="addPage" (click)="addingStepNow$()?null:addStep()">
            <span translate> menuTypes.addStep</span>
            <img *ngIf="!addingStepNow$()" src="/assets/images/steps/add-step.svg" />
            <img *ngIf="addingStepNow$()" src="/assets/images/loading/loading-plus.svg" />
          </div>
        </div>
        <div class="warp-scroll" [ngClass]="{'half-scroll':isOpenAddComponents}" *ngIf="isOpenStepMenu">
          <que-steps-menu [ngClass]="{'addingNow':addingNow}"></que-steps-menu>
        </div>
      </div>
      <div class="section" #warpBoard [style.background]="backColor$ | async">
        <div *ngIf="notLoading$() else loading">
          <ng-container *ngIf="currentStepToEditSignal$()">
            <que-question-board-edit (addingNowEvent)="updateAddingNow($event)" [ngClass]="{'addingNow':addingNow}"
              [formControl]="stepForm">
            </que-question-board-edit>
          </ng-container>
        </div>
      </div>

    </div>
  </div>
  <ng-template #loading>
    <que-loading-board></que-loading-board>
  </ng-template>